<template>
  <div class="legal-page">
    <router-link to="/" class="back-link">
      <span class="material-icons">arrow_back</span>
      {{ $t('legal.backToHome') }}
    </router-link>
    <h1>{{ $t('legal.refund.title') }}</h1>
    <p class="last-updated">{{ $t('legal.refund.lastUpdated') }}</p>

    <h2>{{ $t('legal.refund.overview.title') }}</h2>
    <p>{{ $t('legal.refund.overview.content') }}</p>

    <h2>{{ $t('legal.refund.eligibility.title') }}</h2>
    <p>{{ $t('legal.refund.eligibility.content') }}</p>

    <h2>{{ $t('legal.refund.process.title') }}</h2>
    <p>{{ $t('legal.refund.process.content', { email: 'goodscriber@gmail.com' }) }}</p>

    <h2>{{ $t('legal.refund.nonRefundable.title') }}</h2>
    <p>{{ $t('legal.refund.nonRefundable.content') }}</p>

    <h2>{{ $t('legal.refund.cancellation.title') }}</h2>
    <p>{{ $t('legal.refund.cancellation.content') }}</p>

    <h2>{{ $t('legal.refund.contact.title') }}</h2>
    <p>{{ $t('legal.refund.contact.content', { email: 'goodscriber@gmail.com' }) }}</p>
  </div>
</template>

<script>
export default {
  name: 'RefundPolicy'
}
</script>

<style>
@import '../../styles/legal.css';
</style>
